import axios from 'axios';
import { PostCallPlan } from '../models/AppPostCallPlan';

const API_URL = process.env.REACT_APP_SERVER_URL + "/app/postcallplans";

const authHeader = () => ({
    Authorization: `Bearer ${localStorage.getItem('gpcwstoken_kw')}`,
});

export const AppPostCallPlanService = {
    getPostCallPlansPaginated: async (
        page: number,
        limit: number,
        search?: string,
        warehouseId?: string | number,
        userId?: string | number
    ): Promise<{ plans: PostCallPlan[]; total: number }> => {
        const params: Record<string, any> = { page, limit };
        if (search) params.search = search;
        if (warehouseId !== undefined && warehouseId !== null && warehouseId !== '') params.warehouseId = warehouseId;
        if (userId !== undefined && userId !== null && userId !== '') params.userId = userId;
        const response = await axios.get(`${API_URL}/getPlansPaginated`, { params, headers: authHeader() });
        return response.data;
    },

    getPostCallPlansForToday: async (): Promise<PostCallPlan[]> => {
        const response = await axios.get(`${API_URL}/getPlansForToday`, { headers: authHeader() });
        return response.data;
    },

    getPostCallPlansForThisWeek: async (): Promise<PostCallPlan[]> => {
        const response = await axios.get(`${API_URL}/getPlansForThisWeek`, { headers: authHeader() });
        return response.data;
    },

    getAllPostCallPlans: async (): Promise<PostCallPlan[]> => {
        const response = await axios.get(`${API_URL}/getAllPlans`, { headers: authHeader() });
        return response.data;
    },

    getPostCallPlanById: async (id: number): Promise<PostCallPlan> => {
        const response = await axios.get(`${API_URL}/getPlanById/${id}`, { headers: authHeader() });
        return response.data;
    },

    createPostCallPlan: async (postCallPlan: Omit<PostCallPlan, 'id' | 'created_time' | 'updated_time'>): Promise<PostCallPlan> => {
        const response = await axios.post(`${API_URL}/add`, postCallPlan, { headers: authHeader() });
        return response.data;
    },

    updatePostCallPlan: async (id: number, postCallPlan: Omit<PostCallPlan, 'id' | 'created_time' | 'updated_time'>): Promise<PostCallPlan> => {
        const response = await axios.put(`${API_URL}/update/${id}`, postCallPlan, { headers: authHeader() });
        return response.data;
    },

    deletePostCallPlan: async (id: number): Promise<void> => {
        await axios.delete(`${API_URL}/delete/${id}`, { headers: authHeader() });
    }
};
